<template>
  <gj-modal
      :visible.sync="modalVisible"
      :destroyOnClose="true"
      :footer="false"
      size="normal"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText">
    <template #header>
      <span>导入其他费用</span>
    </template>
    <template #content>
      <el-form
          ref="form"
          v-model="form"
      >
        <el-form-item
            label="导入费用的月份"
            prop="feeMonth"
        >
          <gj-date-picker
              v-model="form.feeMonth"
              type="month"
              :clearable="false"
              width="120px"
          ></gj-date-picker>
        </el-form-item>
        <el-form-item
            label="导入费用的方式"
            prop="feeWay"
        >
          <el-radio-group v-model="form.feeWay">
            <el-radio v-for="(expense,idx) in ExpensesTypeEnum.options" :key="idx" :label="expense.id">
              {{ expense.text }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <gj-upload
          text="导入其他费用"
          class="upload-btn"
          :template-url=" tabsActive === 'market' ? '/finance/financialFeeItemUseDetail/downloadMarketTemplate' : '/finance/financialFeeItemUseDetail/downloadMskuTemplate'"
          container-type="category"
          @uploadAfter="uploadAfter">
        <template #tip>
          <span>只能上传xls/xlsx文件</span>
        </template>
      </gj-upload>
      <gj-import-alert
          :rules="[
            '支持导入格式为xlsx的文件',
            '模板中的表头不可更改，不可删除',
            '数据记录不可超过5000条',
            '按总费用导入时，同一店铺如有多行数据，以最后一行的数据为准',
            '按累计费用导入时，同一店铺如有多行数据会都累加起来',
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, uploadMixin} from "@/minxins";
import {importMarketExcel, importMskuExcel} from "@/api/finance"
import {ExpensesTypeEnum} from "@/views/modules/finance/finance-profit-report/common/enum.js";
import {format,subDays} from "date-fns";

export default {
  name: "import-other-expenses",
  mixins: [modalMixIn, uploadMixin],
  props:{
    tabsActive:{
      type: String,
    }
  },
  data(){
    return {
      form:{
        feeWay: 1,
        feeMonth: new Date(),
      },
      ExpensesTypeEnum: ExpensesTypeEnum,
      disabled: false,
    }
  },
  methods:{
    destroy() {
      this.$gjModal.$gjDestroy();
    },
    proxyBeforeUpload(){
      // let isAllowUpload = true;
      // this.$refs.form.validate(valid => {
      //   isAllowUpload = valid;
      //   this.disabled = valid;
      // })
      // return isAllowUpload;
    },
    uploadAfter(attId, data, uploadCb) {
      const { feeMonth,feeWay } = this.form;
      this.importHandleLoading = true;
      if(this.tabsActive === "market"){
        importMarketExcel(attId, format(feeMonth,'yyyy-MM'), feeWay)
            .then((res) => {
              this.$gjImportHandle(res, uploadCb);
            }).catch(() => {
              uploadCb('error')
            })
            .complete(() => {
              this.importHandleLoading = false
            });
      } else {
        importMskuExcel(attId, format(feeMonth,'yyyy-MM'), feeWay)
            .then((res) => {
              this.$gjImportHandle(res, uploadCb);
            }).catch(() => {
              uploadCb('error')
            })
            .complete(() => {
              this.importHandleLoading = false
            });
      }
    },
  }
}
</script>

<style scoped>
.upload-btn {
  margin: 5px 0 15px;
}
</style>